(() => {
  if (window.tblShippingDisplay) return;
  window.tblShippingDisplay = true;
  const replacements = [
    [/SUNPAN['’]s Houston warehouse currently estimates its next receipt for/gi, 'Stock is currently expected on'],
    [/stock arriving at SUNPAN['’]s warehouse/gi, 'stock becoming available'],
    [/The October 23, 2026 SUNPAN US trade listing provided by the dealer indicates expected Houston receipts on/gi, 'Stock estimates recorded on October 23, 2026 indicate'],
    [/SUNPAN can service the contiguous US and Canada, but its standard trade freight typically requires commercial receiving arrangements\./gi, 'Delivery to the contiguous US and Canada is available subject to confirmation. Standard freight may require commercial receiving arrangements.'],
    [/\bsupplier restock date/gi, 'restock date'],
    [/\bsubject to supplier confirmation/gi, 'subject to confirmation'],
    [/\bstock arrives at the supplier/gi, 'stock becomes available'],
    [/\bsupplier lead times/gi, 'lead times'],
    [/\bmanufacturer availability/gi, 'availability'],
    [/\bmanufacturer['’]s operating and assembly guidance/gi, 'operating and assembly instructions'],
    [/\bmanufacturer['’]s safety guidance/gi, 'safety instructions'],
    [/\bmanufacturer stock/gi, 'stock'],
    [/\blisted by the supplier as/gi, 'listed as'],
    [/\bthe supplier currently offers/gi, 'Available configurations include'],
    [/\bthe supplier currently lists/gi, 'Current listings show'],
    [/\bavailable from the supplier on request/gi, 'available on request'],
    [/\bproduct, supplier, destination/gi, 'product, destination'],
    [/\bsupplier-listed shipping estimates?:/gi, 'Estimated shipping:'],
    [/\bmanufacturer-listed shipping estimate:/gi, 'Estimated shipping:'],
    [/\bmanufacturer-listed factory build time:/gi, 'Estimated build time:'],
    [/\bin-stock items: supplier usually dispatches/gi, 'In-stock orders usually dispatch'],
    [/\bsupplier preparation:/gi, 'Order preparation:'],
    [/\bsupplier dispatch estimate:/gi, 'Estimated dispatch:'],
    [/\bsupplier dispatch:/gi, 'Dispatch:'],
    [/\bsupplier guidance:/gi, 'Estimated timing:'],
    [/\bsupplier estimates/gi, 'estimated timing is'],
    [/\bsupplier availability/gi, 'availability'],
    [/\bsupplier stock/gi, 'stock'],
    [/\bsupplier arrival dates/gi, 'Stock arrival dates'],
    [/\bsupplier commitment/gi, 'order commitment'],
    [/\bsupplier-sourced products/gi, 'standard products'],
    [/\bsupplier-shipped/gi, 'shipped'],
    [/\bsupplier shipment/gi, 'shipment'],
    [/\bsupplier return restrictions/gi, 'return restrictions'],
    [/\bsupplier-listed shipping estimate/gi, 'Estimated shipping'],
    [/\bmanufacturer-listed/gi, 'Estimated'],
    [/\bwork with the supplier on/gi, 'arrange'],
    [/\bmanufacturer warranty terms apply\./gi, 'Warranty terms apply.'],
    [/\bmanufacturer and configuration/gi, 'model and configuration'],
    [/\bproduct and manufacturer/gi, 'product']
  ];
  const clean = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement?.closest('script, style, template')) continue;
      const next = replacements.reduce((text, [pattern, value]) => text.replace(pattern, value), node.data);
      if (next !== node.data) node.data = next;
    }
  };
  const normalize = text => text.toLowerCase().replace(/[–—]/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim();
  const deduplicate = root => {
    const scope = root.closest('.shopify-section');
    const summary = scope?.querySelector('.purchase-facts');
    if (!summary) return;
    const values = [...summary.querySelectorAll('dd')].map(value => {
      const copy = value.cloneNode(true);
      copy.querySelectorAll('a').forEach(link => link.remove());
      return copy.textContent;
    });
    const sentences = values.flatMap(value => {
      const parts = typeof Intl.Segmenter === 'function'
        ? [...new Intl.Segmenter('en', { granularity: 'sentence' }).segment(value)].map(part => part.segment)
        : [value];
      return [value, ...parts].map(normalize).filter(text => text.length > 30);
    });
    const preorderSummary = values.some(value => /pre[ -]order/i.test(value) && /not available for immediate dispatch/i.test(value));
    const isRepeated = text => {
      const normalized = normalize(text);
      return sentences.includes(normalized) || (preorderSummary && /^(?:available for )?pre order(?: only)? not available for immediate dispatch$/.test(normalized));
    };
    root.querySelectorAll('[data-shipping-lead], [data-shipping-delivery], [data-shipping-returns]').forEach(node => node.remove());
    root.querySelectorAll('.product__information-relocated p, .product__information-relocated li').forEach(paragraph => {
      if (paragraph.querySelector('p, ul, ol, table')) return;
      const text = paragraph.textContent;
      if (isRepeated(text)) {
        paragraph.remove();
        return;
      }
      if (typeof Intl.Segmenter !== 'function') return;
      const parts = [...new Intl.Segmenter('en', { granularity: 'sentence' }).segment(text)];
      parts.reverse().forEach(part => {
        if (!isRepeated(part.segment)) return;
        const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
        const range = document.createRange();
        let offset = 0, node, started = false;
        while ((node = walker.nextNode())) {
          const end = offset + node.data.length;
          if (!started && part.index < end) {
            range.setStart(node, part.index - offset);
            started = true;
          }
          if (started && part.index + part.segment.length <= end) {
            range.setEnd(node, part.index + part.segment.length - offset);
            range.deleteContents();
            break;
          }
          offset = end;
        }
      });
      if (!paragraph.textContent.trim()) paragraph.remove();
    });
    root.querySelectorAll('.product__information-relocated').forEach(group => {
      if (!group.textContent.trim()) group.remove();
    });
  };
  const start = () => {
    document.querySelectorAll('.product__shipping-returns').forEach(box => { clean(box); deduplicate(box); });
    new MutationObserver(records => {
      const boxes = new Set();
      for (const record of records) {
        const parent = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        const box = parent?.closest('.product__shipping-returns');
        if (box) boxes.add(box);
        for (const node of record.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (node.matches('.product__shipping-returns')) boxes.add(node);
          node.querySelectorAll('.product__shipping-returns').forEach(box => boxes.add(box));
        }
      }
      boxes.forEach(box => { clean(box); deduplicate(box); });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
